import React, { useState, useEffect } from "react";
import { Layout, Input, Space, Button, Table, message, Form, Popconfirm, Typography, Spin, Select, Upload, Image } from "antd";
import { EditOutlined, DownOutlined, CheckOutlined, CloseOutlined, SearchOutlined, DownloadOutlined, PlusOutlined, DeleteOutlined, UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { Redirect } from "react-router-dom";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import axios from "axios";
import { BaseUrl, FormConfig, } from "../../Repository/BaseRepository";
import Cookies from "js-cookie";
import { DeleteGarnishment } from "../../Repository/GarnishmentRepository";
import { ErrorMessage, InfoMessage, SuccessMessage } from "../../Utils/Utils";
// import './Garnishments.css'
import "../../GlobalCss/SPF/Garnishments.css";
import * as XLSX from "xlsx";
const { Header, Content } = Layout;



const Garnishments = () => {
    const jwtToken = Cookies.get("jwt_token");
    const [garnishmentData, GetGarData] = useState([]);
    const [filteredData, setFilteredData] = useState(garnishmentData);
    const [oldData, setOldData] = useState([]);
    const [garHeaders, getGarHeaders] = useState([])
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState("")
    const [tableLoader, setTableLoader] = useState(false);
    const [loader, setLoad] = useState(false)
    const [loaderDownload, setLoadDownload] = useState(false)
    const [spin, setSpin] = useState(false)
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [file, setFile] = useState([])
    const [garUploader, setgarUploader] = useState("");
    const [form] = Form.useForm();
    const [rowData, setRowData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [EditingRecord, setEditingRecord] = useState(null);
    const IsRecordInEditingState = (Id) => Id === EditingRecord;
    const [NewRecordKey, setNewRecordKey] = useState(null);
    const [searchRow, setSearchRow] = useState("")

    var temp = 0;
    useEffect(() => {
        if (temp === 0) {
            temp = 1;
            callGarn();
            GetHeaders();
        }
    }, []);
    useEffect(() => {
        const applyFilters = () => {
            let result = garnishmentData;
            if (searchRow) {
                result = result.filter(item =>
                    item.Garnishment_type.toLowerCase().includes(searchRow.toLowerCase()) ||
                    item.Employee.toLowerCase().includes(searchRow.toLowerCase()) ||
                    item.File_No.toString().toLowerCase().includes(searchRow.toLowerCase())
                );
            }
            setFilteredData(result);
        };
        applyFilters();
    }, [searchRow, garnishmentData]);
    const callGarn = async () => {
        const res = await Garnishments();
    }

    const isEditing = (record) => record.Id === editingKey;
    const edit = (record) => {
        setRowData(record)
        form.setFieldsValue({
            ...record,
        });
        setEditingKey(record.Id);
    };

    const columns = [
        {
            title: 'Entity',
            dataIndex: 'Entity',
            key: 'Entity',
            width: 100,
            editable: true,
        },
        {
            title: 'File_No',
            dataIndex: 'File_No',
            key: 'File_No',
            width: 100,
            editable: true,
        },
        {
            title: 'SSN',
            dataIndex: 'SSN',
            key: 'SSN',
            width: 100,
            editable: true,
            render: (text, record) => (
                <EditableCell
                    dataIndex={`File_${record.SSN}`}
                    editing={IsRecordInEditingState(record.SSN)}
                >
                    {IsRecordInEditingState(record.SSN)
                        ? text || ""
                        : text
                            ? "*******"
                            : ""}
                </EditableCell>
            ),
        },
        {
            title: 'Employee',
            dataIndex: 'Employee',
            key: 'Employee',
            width: 150,
            editable: true,
            sorter: (a, b) => {
                const A = a.Employee || '';
                const B = b.Employee || '';
                return A.localeCompare(B);
            },
        },
        {
            title: 'Garnishment Type',
            dataIndex: 'Garnishment_type',
            key: 'Garnishment_type',
            width: 200,
            editable: true,
        },
        {
            title: 'Case',
            dataIndex: 'Case',
            key: 'Case',
            width: 80,
            editable: true,
        },
        {
            title: 'Add Info',
            dataIndex: 'Add_Info',
            key: 'Add_Info',
            width: 80,
            editable: true,
        },
        {
            title: 'Amount/Percentage',
            dataIndex: 'Amount_Percentage',
            key: 'Amount_Percentage',
            width: 200,
            editable: true,
        },
        {
            title: 'Pay Frequency Code',
            dataIndex: 'Pay_frequency_code',
            key: 'Pay_frequency_code',
            width: 200,
            editable: true,
        },
        {
            title: 'Verified in Paychex',
            dataIndex: 'Verified_in_paychex',
            key: 'Verified_in_paychex',
            width: 200,
            editable: true,
        },
        {
            title: 'Mode of deduction',
            dataIndex: 'Mode_of_deduction',
            key: 'Mode_of_deduction',
            width: 200,
            editable: true,
        },
        {
            title: 'Gross/Disposable Income',
            dataIndex: 'Gross_disposable_income',
            key: 'Gross_disposable_income',
            width: 200,
            editable: true,
        },
        {
            title: 'Creditor Address',
            dataIndex: 'Creditor_Address',
            key: 'Creditor_Address',
            width: 140,
            editable: true,
        },
        {
            title: 'Input Date',
            dataIndex: 'Input_date',
            key: 'Input_date',
            width: 150,
            editable: true,
            sorter: (a, b) => {
                const A = a.Input_date || '';
                const B = b.Input_date || '';
                return A.localeCompare(B);
            },
        },
        {
            title: 'Limit',
            dataIndex: 'Limit',
            key: 'Limit',
            width: 80,
            editable: true,
        },

        {
            title: 'Remarks',
            dataIndex: 'Remarks',
            key: 'Remarks',
            width: 80,
            editable: true,
        },

        {
            title: 'IsValidated',
            dataIndex: 'IsValidated',
            width: 120,
            filters: [
                {
                    text: 'Yes',
                    value: 'Yes',
                },
                {
                    text: 'No',
                    value: 'No',
                },
                {
                    text: 'Both',
                    value: 'Both',
                },
            ],
            onFilter: (value, record) => {
                if (value === 'Both') {
                    return true;
                } else if (value === 'Yes') {
                    return record.IsValidated && record.IsValidated.startsWith('Yes');
                } else if (value === 'No') {
                    return record.IsValidated && record.IsValidated.startsWith('No');
                }
                return false;
            },
            filterIcon: (filtered) => (
                <DownOutlined style={{ color: filtered ? "#002766" : "#002766" }} />),
            // width: '40%',
            fixed: 'right',
        },

        {
            title: 'Action',
            dataIndex: 'operation',
            fixed: "right",
            width: 80,
            render: (_, record) => {
                return (
                    <>
                        {isEditing(record) ? (
                            // When isEditing is true
                            <div>
                                {record.Id === NewRecordKey ? (
                                    <Popconfirm
                                        title="Sure to Add?"
                                        placement="topRight"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => handleAddNewGarnishment(record)}
                                    >
                                        <PlusOutlined style={{ marginRight: "5px" }} />
                                    </Popconfirm>
                                ) : (
                                    <Popconfirm
                                        title="Sure to Save?"
                                        placement="topRight"
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={() => editfileRowData(record)}
                                    >
                                        <Typography.Link
                                            style={{
                                                marginRight: 8,
                                            }}
                                        >
                                            <CheckOutlined style={{ color: "green", marginRight: "5px" }} />
                                        </Typography.Link>
                                    </Popconfirm>
                                )}

                                <CloseOutlined
                                    style={{ color: "red" }}
                                    onClick={() => {
                                        if (record.Id === NewRecordKey) {
                                            GetGarData(oldData);
                                            setEditingKey("");
                                            setNewRecordKey("");
                                        } else {
                                            setEditingKey("");
                                            setNewRecordKey("");
                                        }
                                    }}
                                />
                            </div>
                        ) : (
                            // When isEditing is false and NewRecordKey is not "tempId"
                            <div>
                                <Typography.Link onClick={() => edit(record)}>
                                    <EditOutlined
                                        style={{ marginRight: "5px", color: "blue" }}
                                        onClick={() => {
                                            form.setFieldsValue({ ...record });
                                            setEditingKey(record.Id);
                                        }}
                                    />
                                </Typography.Link>
                                <Popconfirm
                                    title="Are you sure want to delete?"
                                    onConfirm={() => handleDeleteGarnishment(record.Id)}
                                    okText="Yes"
                                    cancelText="No"
                                >
                                    <DeleteOutlined style={{ color: "red" }} />
                                </Popconfirm>
                            </div>
                        )}
                    </>
                );
            },
        },
    ];

    const EditableCell = ({
        editing,
        dataIndex,
        title,
        inputType,
        record,
        index,
        children,
        ...restProps
    }) => {
        const inputNode = <Input />;
        return (
            <td {...restProps}>
                {editing ? (
                    <Form.Item
                        name={dataIndex}
                        style={{
                            margin: 0,
                        }}
                    >
                        {inputNode}
                    </Form.Item>
                ) : (
                    children
                )}
            </td>
        );
    };
    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    const onSelectChange = (selectedKeys) => {
        setSelectedRowKeys(selectedKeys);
    };
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    };


    const AddNewRecord = async () => {
        if (editingKey === "") {
            let NewRecordArray = {};
            for (let index in columns) {
                NewRecordArray[columns[index].dataIndex] = "";
            }

            NewRecordArray.Id = "0";
            setOldData([...garnishmentData]);
            GetGarData([NewRecordArray, ...garnishmentData]);
            form.setFieldsValue({ ...NewRecordArray });
            setNewRecordKey("0");
            setEditingKey("0");
        } else {
            InfoMessage("Please save/discard the record");
        }
    };
    //Api for getting all records
    const Garnishments = async () => {
        try {
            setTableLoader(true)
            await axios({
                url:
                    `${process.env.REACT_APP_BASE_URL}Garnishments/GetGarnishments`,
                method: "GET",
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                },
            })
                .then((resp) => {
                    GetGarData(resp.data)
                    setTableLoader(false)
                })

        }
        catch (error) {
            setTableLoader(false)
            message.error("Error while fetching data!")
        }
    };

    //Delete Functionality
    const handleDeleteGarnishment = async (Id) => {
        const Response = await DeleteGarnishment(Id);
        Response.isSuccess === true
            ? SuccessMessage(Response.message)
            : ErrorMessage(Response.message);
        Garnishments();
    };

    //Add row Functionalty
    const handleAddNewGarnishment = async (props) => {
        try {
            let NewRecord = await form.getFieldsValue();
            if (!NewRecord.Entity || !NewRecord.File_No || !NewRecord.SSN) {
                message.error("Please enter required fields.");
                return;
            }
            const data = {
                "id": NewRecord.Id,
                "entity": NewRecord.Entity,
                "file_no": NewRecord.File_No,
                "ssn": NewRecord.SSN,
                "employee": NewRecord.Employee,
                "garnishment_type": NewRecord.Garnishment_type,
                "case": NewRecord.Case,
                "add_Info": NewRecord.Add_Info,
                "amount_Percentage": NewRecord.Amount_Percentage,
                "pay_frequency_code": NewRecord.Pay_frequency_code,
                "verified_in_paychex": NewRecord.Verified_in_paychex,
                "mode_of_deduction": NewRecord.Mode_of_deduction,
                "gross_disposable_income": NewRecord.Gross_disposable_income,
                "creditor_Address": NewRecord.Creditor_Address,
                "input_date": NewRecord.Input_date,
                "limit": NewRecord.Limit,
                "remarks": NewRecord.Remarks
            }
            // NewRecord.Id = parseInt("0");
            const config = {
                headers: {
                    "content-type": "application/json",
                    Authorization: `Bearer ${jwtToken}`,
                }
            }
            const url = `${process.env.REACT_APP_BASE_URL}Garnishments/AddRecord`
            const response = await
                axios.post(url, data, config)
            if (response.StatusCode == 200) {
                message.success(`Added successfully.`);
            }
            else if (response.StatusCode == 500) {
                message.warning(response.message)
            }
            Garnishments();
            setEditingKey("");
        }
        catch (err) {
            message.error("Error,try again")
        }
    };

    const compareObjects = (obj1, obj2) => {
        const keys1 = Object.keys(obj1);
        const keys2 = Object.keys(obj2);
        if (keys1.length !== keys2.length || !keys1.every(key => keys2.includes(key))) {
            return false;
        }
        for (const key of keys1) {
            if (obj1[key] !== obj2[key]) {
                return false;
            }
        }
        return true;
    };

    const compareLists = (rowData, currentRowData) => {
        if (typeof rowData !== 'object' || typeof currentRowData !== 'object') {
            return false;
        }
        const result = compareObjects(rowData, currentRowData);
        return result;
    };
    //Updating record
    const editfileRowData = async (props) => {
        try {
            const currentRowData = await form.getFieldValue();
            const comparision = compareLists(rowData, currentRowData);
            if (comparision === false) {
                const data = {
                    "id": currentRowData.Id,
                    "entity": currentRowData.Entity,
                    "file_no": currentRowData.File_No,
                    "ssn": currentRowData.SSN,
                    "employee": currentRowData.Employee,
                    "garnishment_type": currentRowData.Garnishment_type,
                    "case": currentRowData.Case,
                    "add_Info": currentRowData.Add_Info,
                    "amount_Percentage": currentRowData.Amount_Percentage,
                    "pay_frequency_code": currentRowData.Pay_frequency_code,
                    "verified_in_paychex": currentRowData.Verified_in_paychex,
                    "mode_of_deduction": currentRowData.Mode_of_deduction,
                    "gross_disposable_income": currentRowData.Gross_disposable_income,
                    "creditor_Address": currentRowData.Creditor_Address,
                    "input_date": currentRowData.Input_date,
                    "limit": currentRowData.Limit,
                    "remarks": currentRowData.Remarks
                }
                const config = {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    }
                }
                const url = `${process.env.REACT_APP_BASE_URL}Garnishments/UpdateGarnishment`
                const response = await
                    axios.put(url, data, config)
                if (response.StatusCode == 200) {
                    message.success(`Updated successfully.`);
                }
                else if (response.StatusCode == 500) {
                    message.warning(response.message)
                }
                Garnishments();
                setEditingKey("");
            }
            else {
                InfoMessage("No changes made. Edit and try again.")
            }
        }
        catch (err) {
            message.error("Error,try again")
        }

    }

    const GetHeaders = () => {
        axios({
            url:
                `${process.env.REACT_APP_BASE_URL}Garnishments/GarnishmentTemplate`,
            method: "GET",
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            },
        })
            .then((resp) => {
                getGarHeaders(resp.data)
            })
    }

    //Api for uploading file
    const handleUpload = async (options) => {
        try {
            setSpin(true)
            // setTableLoader(true)
            const { file, onSuccess, onError } = options;
            // Checking file type
            const fileType = file.type;
            const validTypes = ['application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'];
            if (!validTypes.includes(fileType)) {
                message.error("Invalid file type. Please upload an Excel file.");
                setSpin(false)
                onError(file);
                return;
            }

            const updatedFile = { file, status: "uploading" }
            const formData = new FormData();
            formData.append("file", file);
            setFile([])
            setgarUploader(file.name);
            const response = await axios.post(`${BaseUrl}Garnishments/GarnishmentsUpload`, formData, FormConfig)
            if (response.data.isSuccess === true) {
                onSuccess(file)
                message.success(`File uploaded successfully`);
                updatedFile.status = "done"
                setFile([updatedFile])
                setgarUploader('')
                setSpin(false)
                // setTableLoader(false)
                Garnishments()
            }
            else {
                onError(file)
                message.error("File upload failed");
                updatedFile.status = "error"
                setFile([updatedFile])
                setgarUploader('')
                setSpin(false)
                // setTableLoader(false)
            }
        }
        catch (error) {
            message.error(`File upload failed`);
            setgarUploader('')
            setSpin(false)
            // setTableLoader(false)
        }
    }
    const itemRender = (originNode, file) => {
        let statusColor = file.status === "done" ? "green" : "#f55451";
        return (
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <div style={{ marginRight: "10px", color: statusColor }}>
                    {file.file.name}
                </div>
                <div>
                    <DeleteOutlined onClick={() => setFile([])} />
                </div>
            </div>
        );
    };

    //Api for validating records
    const ValidateRecords = async () => {
        const config = {
            headers: {
                "content-type": "application/json",
                Authorization: `Bearer ${jwtToken}`,
            }
        }
        if (selectedRowKeys.length == 0) {
            message.warning("Please select records to validate!")
        }
        else {
            const alreadyValidated = selectedRowKeys.some(key => {
                const record = filteredData.find(item => item.Id === key);
                return record && record.IsValidated && record.IsValidated.startsWith('Yes');
            });
            if (alreadyValidated) {
                message.info("Already validated. Please select other records.");
                return;
            }
            setLoad(true)
            try {
                const url = `${process.env.REACT_APP_BASE_URL}Garnishments/ValidateGarnishment`
                const data = selectedRowKeys
                const response = await
                    axios.put(url, data, config)
                        .then((response) => {
                            message.success(`Validated successfully.`);
                            setLoad(false)
                        })
                Garnishments()
            }
            catch (error) {
                message.error("Error,Try again")
            }
        }
    };

    //garnishments file download method
    const handleGarnishments = async (props) => {
        let value = props.value;
        setLoadDownload(true);
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_BASE_URL}Garnishments/DownloadFile?Validate=` + value,
                {
                    headers: {
                        "content-type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            let resdata = res.data;
            handleGarnishmentList(resdata)
        } catch (err) {
            setLoadDownload(false);
            message.error("Cannot able download, please try again")
        }
    };

    const handleGarnishmentList = (props) => {
        let sampleList = props;
        let loopedList = [];
        loopedList.length = 0;
        let len = sampleList.length;
        let i;
        for (i = 0; i < len; i++) {
            loopedList.push({
                Entity: sampleList[i].entity,
                File_No: sampleList[i].file_No,
                SSN: sampleList[i].ssn,
                Employee: sampleList[i].employee,
                Garnishment_type: sampleList[i].garnishment_type,
                Case: sampleList[i].case,
                Add_Info: sampleList[i].add_Info,
                Amount_Percentage: sampleList[i].amount_Percentage,
                Pay_frequency_code: sampleList[i].pay_frequency_code,
                Verified_in_paychex: sampleList[i].verified_in_paychex,
                Mode_of_deduction: sampleList[i].mode_of_deduction,
                Gross_disposable_income: sampleList[i].gross_disposable_income,
                Creditor_Address: sampleList[i].creditor_Address,
                Input_date: sampleList[i].input_date,
                Limit: sampleList[i].limit,
                IsValidated: sampleList[i].isValidated,
            });
        }
        setLoadDownload(false);
        handleOnGarnishmentExport(loopedList);
    };
    const handleOnGarnishmentExport = (props) => {
        const listData = props.map((row) => {
            const sanitizedRow = {};
            Object.keys(row).forEach((key) => {
                sanitizedRow[key] = sanitizeCellValue(row[key]);
            });
            return sanitizedRow;
        });

        var wb = XLSX.utils.book_new(),
            ws = XLSX.utils.json_to_sheet(listData);
        XLSX.utils.book_append_sheet(wb, ws, "Myfile");
        XLSX.writeFile(wb, "Garnishments.xlsx");
    };

    // Function to sanitize cell values
    const sanitizeCellValue = (value) => {
        if (typeof value === "string" && /^[=+\-@]/.test(value)) {
            return `'${value}`; // Prefix with an apostrophe
        }
        return value;
    };

    // Template generation also needs sanitization
    const handleGarnishmentsTemplate = () => {
        const sanitizedHeaders = garHeaders.map(sanitizeCellValue);
        const worksheet = XLSX.utils.aoa_to_sheet([sanitizedHeaders]);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        const excelBuffer = XLSX.write(workbook, { type: "buffer" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const downloadLink = document.createElement("a");
        downloadLink.href = URL.createObjectURL(blob);
        downloadLink.download = "GarnishmentsTemplate.xlsx";
        downloadLink.click();
    };


    if (jwtToken === undefined) {
        return <Redirect to="/" />;
    }
    return (
        <>
            <Layout style={{ backgroundColor: "white", height: "100vh", display: "flex", overflow: "hidden" }} >
                <SideNavBar />
                <Layout className="whole-div">
                    <Header className="timecards-header">
                        <Navbar />
                    </Header>
                    <Content style={{ height: "100%", overflow: "auto" }}>
                        <div>
                            <div className="garnishments-title">Garnishments</div>
                            <div className="garnishmnet-input-div">
                                <Button className="add-row" onClick={() => AddNewRecord()}>Add New Record<PlusOutlined /></Button>
                                <Input
                                    placeholder="Search Employee Name \ Garnishment type \ File Number"
                                    className="gar-searchrow"
                                    style={{ borderColor: "rgba(59, 82, 223, 1)", color: "rgba(59, 82, 223, 1)" }}
                                    onChange={(e) => setSearchRow(e.target.value)}
                                    allowClear
                                    suffix={
                                        <SearchOutlined
                                            style={{ color: "rgba(59, 82, 223, 1)", justifyContent: "space-between" }}
                                        />
                                    }
                                />
                                <Button onClick={handleGarnishmentsTemplate} className="template-download-garbutton">Download Template<DownloadOutlined /></Button>
                                <div className="garfile-upload">
                                    <Upload
                                        name="file"
                                        className="gar-upload-file"
                                        customRequest={handleUpload}
                                        itemRender={itemRender}
                                        fileList={file}
                                        accept=".xls,.xlsx"
                                        onRemove={() => setFile([])}
                                        style={{ border: "1px solid #002766", borderRadius: 10, borderStyle: "dashed" }}
                                    >
                                        <div className='gar-content-file'>
                                            <span className="garfile-name">Upload File</span>
                                            {spin ? <Spin indicator={<LoadingOutlined className="upload-spinner" style={{ fontSize: 16, marginLeft: 7 }} spin />} />
                                                : <Image src="/Images/uploadimg.png"
                                                    style={{
                                                        border: "none",
                                                        width: 19,
                                                        height: 17,
                                                    }}
                                                    showPreviewIcon={false}
                                                    preview={false} />}
                                        </div>
                                    </Upload>
                                    {garUploader.length > 0 ? <div style={{ marginBottom: 2, color: "rgba(0, 39, 102, 1)" }}>{garUploader}</div> : null}
                                </div>
                                <Select
                                    labelInValue
                                    defaultValue={{
                                        value: 'Download File',
                                        label: 'Download File',
                                    }}
                                    style={{
                                        width: 170, height: 42
                                    }} size="large"
                                    onSelect={handleGarnishments}
                                    options={[
                                        {
                                            value: 'Yes',
                                            label: 'Verified',
                                        },
                                        {
                                            value: 'No',
                                            label: 'Unverified',
                                        },
                                        {
                                            value: 'Both',
                                            label: 'All',
                                        },
                                    ]}
                                    className="gar-down-select"
                                    loading={loaderDownload}
                                // allowClear
                                />
                            </div>
                            <div className="garnishmnet-table-div">
                                {
                                    tableLoader ? <Spin tip="Loading...">
                                        <Form form={form} component={false}>
                                            <Table className="garnishments-table" rowClassName="editable-row"
                                                components={{ body: { cell: EditableCell, }, }}
                                                bordered
                                                scroll={{ x: "max-content", y: 350 }}
                                                columns={mergedColumns}
                                                dataSource={filteredData.map(item => ({ ...item, key: item.Id }))}
                                                rowSelection={rowSelection}
                                            pagination={false}
                                            />
                                        </Form>
                                    </Spin> : garnishmentData ?
                                        <Form form={form} component={false}>
                                            <Table className="garnishments-table" rowClassName="editable-row"
                                                components={{ body: { cell: EditableCell, }, }}
                                                columns={mergedColumns}
                                                bordered
                                                dataSource={filteredData.map(item => ({ ...item, key: item.Id }))}
                                                scroll={{ x: "max-content", y: 350 }}
                                                rowSelection={rowSelection}
                                            // pagination={false}
                                            />
                                        </Form>
                                        : null
                                }
                            </div>

                            <div className="garnishmnet-buttons-div">
                                <Button className="validate-garnishment" loading={loader} onClick={ValidateRecords}>Validate</Button>
                            </div>
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    )
}
export default Garnishments;